import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const normalizeStoredValue = (value) => {
  if (!value || value === "null" || value === "undefined") {
    return null;
  }

  return value;
};

const parseStoredJson = (key) => {
  const normalized = normalizeStoredValue(localStorage.getItem(key));

  if (!normalized) return null;

  try {
    return JSON.parse(normalized);
  } catch (_error) {
    localStorage.removeItem(key);
    return null;
  }
};

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    refreshToken: null,
    // Perfil e permissoes do admin logado ({ profile, permissions }). Vem do
    // login e do GET /me (a cada carga da pagina); ver shared/permissions.js.
    access: null,
    accessLoaded: false,
  },
  getters: {
    token: ({ token }) => token,
    user: ({ user }) => user,
    access: ({ access }) => access,
    accessLoaded: ({ accessLoaded }) => accessLoaded,
    authenticated: ({ token, user }) => {
      return !!normalizeStoredValue(token) && !!normalizeStoredValue(user);
    },
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;

      if (!payload) {
        localStorage.removeItem("user");
        return;
      }

      localStorage.setItem("user", JSON.stringify(payload));
    },
    SET_TOKEN(state, payload) {
      state.token = payload;

      if (!payload) {
        localStorage.removeItem("token");
        return;
      }

      localStorage.setItem("token", payload);
    },
    SET_ACCESS(state, payload) {
      state.access = payload;
      state.accessLoaded = !!payload;

      if (!payload) {
        localStorage.removeItem("access");
        return;
      }

      localStorage.setItem("access", JSON.stringify(payload));
    },
    SET_ACCESS_LOADED(state, payload) {
      state.accessLoaded = payload;
    },
    SET_REFRESH_TOKEN(state, payload) {
      state.refreshToken = payload;

      if (!payload) {
        localStorage.removeItem("refreshToken");
        return;
      }

      localStorage.setItem("refreshToken", payload);
    },
  },
  actions: {
    initializeStore({ commit }) {
      return new Promise((resolve) => {
        const token = normalizeStoredValue(localStorage.getItem("token"));
        const user = parseStoredJson("user");
        const access = parseStoredJson("access");
        const refreshToken = normalizeStoredValue(
          localStorage.getItem("refreshToken")
        );

        if (token && user) {
          commit("SET_TOKEN", token);
          commit("SET_USER", user);

          if (refreshToken) {
            commit("SET_REFRESH_TOKEN", refreshToken);
          }

          // O guardado so serve ate o GET /me responder: accessLoaded fica
          // falso para a guarda de rota buscar o atual.
          if (access) {
            commit("SET_ACCESS", access);
            commit("SET_ACCESS_LOADED", false);
          }
        }

        resolve();
      });
    },

    setSignIn({ dispatch }, payload) {
      dispatch("setUser", payload.user);
      dispatch("setToken", payload.token);
      dispatch("setRefreshToken", payload.refreshToken);
      dispatch("setAccess", payload.access || null);
    },
    setAccess({ commit }, payload) {
      commit("SET_ACCESS", payload);
    },
    // Recarrega usuario, perfil e permissoes da API. Falha (rede, 401) deixa o
    // acesso guardado: quem decide a sessao e o BaseAPIClient.
    async loadAccess({ commit, state }) {
      const { default: api } = await import("@/shared/api");
      try {
        const { data } = await api.getMe();
        commit("SET_USER", data.admin);
        commit("SET_ACCESS", data.access);
      } catch (_error) {
        commit("SET_ACCESS_LOADED", true);
      }
      return state.access;
    },
    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },
    setToken({ commit }, payload) {
      commit("SET_TOKEN", payload);
    },
    setRefreshToken({ commit }, payload) {
      commit("SET_REFRESH_TOKEN", payload);
    },
  },
  modules: {},
});
